// Standard map tile configurations with high-resolution Google Maps & Satellite layers
// Supports deep ground-level zoom up to level 22 (buildings, gates, doorways) at zero cost.

export const MAP_TILES = {
  googleHybrid: {
    id: 'googleHybrid',
    name: '🛰️ Google Satellite',
    url: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    attr: '© Google Maps',
    maxZoom: 22,
    maxNativeZoom: 21,
  },
  googleStreet: {
    id: 'googleStreet',
    name: '🗺️ Google Street',
    url: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    attr: '© Google Maps',
    maxZoom: 22,
    maxNativeZoom: 21,
  },
  esriSatellite: {
    id: 'esriSatellite',
    name: '🌍 Esri Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attr: '© Esri World Imagery',
    maxZoom: 20,
    maxNativeZoom: 19,
  },
  osm: {
    id: 'osm',
    name: '🗺️ OpenStreetMap',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attr: '© OpenStreetMap contributors',
    maxZoom: 19,
    maxNativeZoom: 19,
  },
};

export const DEFAULT_TILE = 'googleHybrid';
